// Translations
import accessKeyInformationForm from '../components/access-key-information-form/translations/ru'

// Translation: Model > Access key manager > Access key managing dialog (Russian)
export default Object.freeze({
	actions: {
		cancel: '',
		create: '',
		save: ''
	},
	components: { accessKeyInformationForm },
	message: {
		text: {
			information: '',
			instructions: ''
		},
		title: ''
	},
	title: {
		creating: '',
		editing: ''
	}
})
